module.exports = __webpack_public_path__ + "static/opis-inwestycji-tablet-e2b846ac33c87e3742b3c464a0d6216b.jpg";